import { catchError, finalize, map, tap } from 'rxjs/operators';
import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService, IModel } from '../../../../core/service/base/data.service';

import { APP_CONFIG, IAppConfig } from './../../../../app.config';
import { Observable } from 'rxjs';
import { ProgressBarService } from '../../../../core/service/progress-bar.service';
import { MessageService } from '../../../../core/service/message.service';
import { FilterModelBase } from '../../../../core/model/filter-model-base';
import { PagedFilter } from '../../../../core/model/paged-filter';
import { RentInvoicingOrderCreateModel } from '../../../model/rent-invoicing/rent-invoicing-order-create-model';
import { RentInvoicingOrderUpdateModel } from '../../../model/rent-invoicing/rent-invoicing-order-update-model';
import { RentInvoicingOrderStatus } from '../../../model/rent-invoicing/rent-invoicing-order-status';
import { RentInvoicingOrderListItem } from '../../../model/rent-invoicing/rent-invoicing-order-list-item';
import { RentInvoicingOrderDetailsService } from './rent-invoicing-order-details.service';

export class RentInvoicingOrderFilter extends FilterModelBase {
  status: RentInvoicingOrderStatus;
}

@Injectable()
export class RentInvoicingOrderService extends DataService<
  RentInvoicingOrderListItem,
  RentInvoicingOrderCreateModel,
  RentInvoicingOrderUpdateModel
> {
  private readonly _defaultFilterFields: string[] = ['status'];

  constructor(
    client: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    messageService: MessageService,
    progressBar: ProgressBarService,
    private _detailsService: RentInvoicingOrderDetailsService
  ) {
    super(client, config, messageService, RentInvoicingOrderListItem, progressBar, 'rent-invoicing-order');
  }

  override createNew(model: RentInvoicingOrderCreateModel, options?: { notifyUser: boolean }): Observable<IModel> {
    return this._detailsService.createNew(model, options);
  }

  getFilterDefinition(): Observable<PagedFilter<RentInvoicingOrderFilter>> {
    return this.client.get<PagedFilter<RentInvoicingOrderFilter>>(`${this.endpoint}/filter`).pipe(
      catchError(error => {
        console.log(error);
        return [];
      })
    );
  }

  prepareFilter(filter: any): any {
    super.prepareFilter(filter);
    if (filter.status === -1 || filter.status === '') {
      filter.status = null;
    }
    return filter;
  }

  add(model: RentInvoicingOrderListItem, options?: { notifyUser: boolean }): Observable<any> {
    // Unsupported.
    throw new Error();
  }

  get(id: string): Observable<RentInvoicingOrderListItem> {
    // TODO: Add generic parameter for details model type.
    throw new Error('Not supported. Use RentInvoicingOrderDetailsService instead.');
  }
}
